import {
  createSeenCountRequest,
  updateSeenCountRequest,
} from "../../../modules/students-modules/videos/Actions";

export const getViewsCount = (data) => Number(data?.views_count?.views_count) || 0;

const hasControlValue = (data) =>
  data?.auto_controlled != null && data?.auto_controlled !== "";

export const isDurationControlled = (data) =>
  Number(data?.video_type) === 1 &&
  hasControlValue(data) &&
  Number(data.auto_controlled) !== 0;

export const isClickControlled = (data) =>
  Number(data?.video_type) !== 1 &&
  hasControlValue(data) &&
  Number(data.auto_controlled) !== 0;

export const allowedClicks = (data) => {
  const value = Number(data?.auto_controlled);
  return value === 1 ? 2 : value;
};

export const isClickSuspended = (data) =>
  isClickControlled(data) && getViewsCount(data) >= allowedClicks(data);

export const isClickPlaybackBlocked = (data) =>
  isClickControlled(data) && getViewsCount(data) > allowedClicks(data);

export const isDurationExceeded = (data) =>
  Number(data?.video_type) === 1 && getViewsCount(data) === 4;

export const isHomeworkExamSuspended = (data) =>
  data?.suspended == 1 && data?.user_video_suspended != 0;

export const getViewsExceededMessage = () => "You have exceeded your views";

export const getHomeworkExamMessage = (data) => {
  const names = [data?.homework?.name, data?.exams?.name].filter(Boolean);
  if (!names.length) return "Video is suspended";
  return `Video is suspended Solve ${names.join(" or ")}`;
};

export const getVideoLockMessage = (data) => {
  if (isDurationExceeded(data) || isClickSuspended(data)) {
    return getViewsExceededMessage();
  }
  if (isHomeworkExamSuspended(data)) {
    return getHomeworkExamMessage(data);
  }
  return null;
};

const createUserVideo = (dispatch, data, viewsCount) => {
  dispatch(
    createSeenCountRequest({
      video_id: data.id,
      seen: true,
      views_count: viewsCount,
      exception: 0,
      user_video_suspended: 0,
      total_covered: 0,
      total_played: 0,
    })
  );
};

export const countSeens = (dispatch, data) => {
  if (!data?.id || data?.suspended == 1) return;

  if (isDurationControlled(data)) {
    if (!data?.views_count) createUserVideo(dispatch, data, 0);
    return;
  }

  if (!isClickControlled(data) || isClickSuspended(data)) return;

  if (!data?.views_count) {
    createUserVideo(dispatch, data, 1);
    return;
  }

  if (getViewsCount(data) < allowedClicks(data)) {
    dispatch(updateSeenCountRequest({ video_id: data.id }));
  }
};
